/**
 * @author Michael Hasenstein <hasenstein@yahoo.com>
 * @copyright REFINIO GmbH 2018
 * @license CC-BY-NC-SA-2.5; portions MIT License
 * @version 0.0.1
 */
import { createError } from '../errors.js';
export const isWebWorker = typeof WorkerGlobalScope !== 'undefined' &&
    typeof importScripts === 'function' &&
    self instanceof WorkerGlobalScope;
// isBrowser should be true for both main thread browser AND Web Workers
export const isBrowser = (typeof window !== 'undefined' && typeof window.document !== 'undefined') ||
    isWebWorker;
export const isNode = typeof process === 'object' &&
    typeof process.versions === 'object' &&
    typeof process.versions.node === 'string';
// We're not running in Expo/React Native - this is desktop Electron
export const isExpo = false;
export const SYSTEM = isNode ? 'nodejs' : 'browser';
export function setPlatformLoaded(pl) {
    // Web Workers are considered browser platform
    if ((isBrowser && pl !== 'browser') || (isNode && pl !== 'nodejs') || (isWebWorker && pl !== 'browser')) {
        console.error('[PLATFORM] Throwing PL-SPL1 error - invalid platform combination');
        throw createError('PL-SPL1', { SYSTEM, pl });
    }
    globalThis.__ONE_CORE_PLATFORM_LOADED__ = true;
}
export function ensurePlatformLoaded() {
    const loaded = globalThis.__ONE_CORE_PLATFORM_LOADED__;
    if (!loaded) {
        console.error('[PLATFORM] Platform not loaded! Throwing PL-CPL1');
        throw createError('PL-CPL1');
    }
}
//# sourceMappingURL=platform.js.map